import { ReactNode } from 'react'
import { RestrictedAddressPage } from '@/containers/RestrictedAddress'
import { Address } from 'viem'
import { OFAC_BLACKLIST } from './logic/ofacBlacklist'
import { useAccount } from 'wagmi'

export function CheckOFAC({ children }: { children: ReactNode }) {
  const { address: walletAddress } = useAccount()

  const address = walletAddress as Address | undefined

  if (address && OFAC_BLACKLIST.includes(address.toLowerCase() as Address)) {
    return <RestrictedAddressPage address={address} />
  }

  return children
}
